import React, { useEffect } from "react";
import Data from "../../dummy";
import Interview from "./Interview";
import httpBlob from "../../../helpers/http-blob";
import { ToastContainer } from "react-toastify";

import {
  fetchCategoryQuestions,
  saveVideoStep,
  finishInterview
} from "../../../states/actions/fetchCategoryQuestions";
import { useDispatch, useSelector } from "react-redux";
import useDocumentTitle from "../../../hooks/useDocumentTitle";
import LoadingScreen from "../../common/LoadingScreen";
import Text from "../../common/Text";
import ImageControl from "../../common/ImageControl";
import { Link, useParams } from "react-router-dom";

const VideoInterview = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchCategoryQuestions.content);
  const isLoading = useSelector(
    (state) => state.fetchCategoryQuestions.isLoading
  );
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );

  const { questions } = data;

  useEffect(() => {
    localStorage.setItem("interview_session_id", "");
  }, []);

  useEffect(() => {
    dispatch(fetchCategoryQuestions({ id }));
  }, []);

  const saveVideo = (formData) => {
    dispatch(saveVideoStep(formData));
  };

  const handleFinishProcess = (formData) => {
    dispatch(finishInterview(formData));
  };

  useDocumentTitle(data.page_title);
  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <ToastContainer />
          <Interview
            data={Data.interview}
            saveVideo={saveVideo}
            handleFinishProcess={handleFinishProcess}
            questions={questions}
          />
        </>
      )}
    </>
  );
};

export default VideoInterview;
